__turbopack_context__.v({
  "calloutSection": "f2QK0a_calloutSection",
  "contactModal": "f2QK0a_contactModal",
  "footer": "f2QK0a_footer",
  "header": "f2QK0a_header",
  "homeBenefitsSection": "f2QK0a_homeBenefitsSection",
  "homeCaseStudiesSection": "f2QK0a_homeCaseStudiesSection",
  "homeLoginSection": "f2QK0a_homeLoginSection",
  "homeProductsSection": "f2QK0a_homeProductsSection",
  "homeSolutionsSection": "f2QK0a_homeSolutionsSection",
  "homeTopSection": "f2QK0a_homeTopSection",
  "root": "f2QK0a_root",
  "serviceMessage": "f2QK0a_serviceMessage",
});
